import { DocumentTypeEnum, EFileType, FileTypeEnum } from '@/constant';
import { TDefineDocumentAreaDetailStore } from '@/stores';
import { MyPageSelectors } from '@/stores/my-page';
import { NOOP } from '@/utils';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DefinePreviewFileServerButton } from '..';
import { DefineDocumentWriteModeEnum } from '../define-document-write/define-document-write.type';
import PreviewFileButton from '../define-document-write/preview-file-button';

type TTypeNameDocument = {
	record: TDefineDocumentAreaDetailStore;
};

const TypeNameDocument = ({ record }: TTypeNameDocument) => {
	const { t } = useTranslation('common');
	const { isForeignRole } = useSelector(MyPageSelectors.selectDataMyPage);

	return (
		<div className="flex items-center justify-center gap-[10px]">
			<p>
				{record.type === FileTypeEnum.FORM ? t('form-electric') : t('upload')}
			</p>
			{!isForeignRole && (
				<>
					{record?.type === FileTypeEnum.FORM ? (
						<PreviewFileButton
							documentType={record?.documentType as unknown as DocumentTypeEnum}
							rowId={Number(record?.id)}
							fileId={Number(record?.id)}
							onUploaded={NOOP}
							mode={DefineDocumentWriteModeEnum.REPLACE}
							refTableName={record?.refTableName}
							refTableId={record?.refTableId}
							mappingList={record?.mappingList}
						/>
					) : (
						<DefinePreviewFileServerButton
							fileList={[
								{
									sourceType: EFileType.SERVER,
									file: {
										fileId: record?.fileId,
										name: record?.name,
										path: record?.path,
										type: record?.type,
									},
								},
							]}
						/>
					)}
				</>
			)}
		</div>
	);
};

export default memo(TypeNameDocument);
